import addFromAndTo from './AddFromAndTo';

const processTimeFrameData = (
  obj: any,
  fromYear: string,
  toYear: string
): any => {
  if (obj && typeof obj === 'object') {
    if ('timeFrameData' in obj) {
      if (Array.isArray(obj?.timeFrameData)) {
        addFromAndTo(obj, fromYear, toYear);
      }
    }

    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        obj[key] = obj[key].map((item: any) =>
          processTimeFrameData(item, fromYear, toYear)
        );
      } else if (typeof obj[key] === 'object') {
        obj[key] = processTimeFrameData(obj[key], fromYear, toYear);
      }
    }
  }

  return obj;
};

export default processTimeFrameData;
